<template>
  <div
    class="filters"
    :class="{ 'filters--design-new': design === 'new', 'filters--refined': refined, 'filters--medium': weight === 'medium', 'filters--wrap': design === 'new' && wrap }"
    :role="design === 'new' ? 'radiogroup' : null"
  >
    <label
        v-for="filter of filters"
        :key="filter.value"
        class="filters__label">
      <input
        @change="$emit('change', $event.target.value)"
        type="radio"
        :name="name"
        :value="filter.value"
        :checked="filter.value === value"
      >
      <span
        class="filters__item"
        :class="filter.tone ? `filters__item--${filter.tone}` : null"
      >{{ filter.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppFilters',
  props: {
    filters: {
      type: Array,
      required: true,
    },
    name: String,
    value: String,
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    },
    refined: Boolean,
    wrap: Boolean,
    weight: {
      type: String,
      default: 'default',
      validator: value => ['default', 'medium'].includes(value)
    }
  },
  model: {
    event: 'change',
    prop: 'value'
  }
}
</script>

<style lang="sass">
.filters
  display: flex
  flex-shrink: 0
  overflow: hidden
  border: 1px solid #dbdbdb
  border-radius: 6px

  input[type="radio"]
    +visually-hidden

    &:checked + .filters__item
      background-color: $color-theme
      color: #fff
      pointer-events: none

.filters__label
  border-right: 1px solid #dbdbdb

  &:last-child
    border: none

.filters__item
  display: block
  padding: 10px 20px
  background-color: #fff
  font-size: 14px
  cursor: pointer
  transition: opacity 0.3s

  &:hover
    opacity: 0.7

.filters--design-new
  min-height: $ui-control-height
  border-color: $ui-line-strong
  border-radius: $ui-control-radius
  background-color: $ui-surface
  font-family: $ui-font-body

  .filters__label
    border-right-color: $ui-line-strong

  .filters__item
    display: flex
    align-items: center
    min-height: $ui-control-height
    padding: 0 $ui-space-16
    color: $ui-text
    font-size: $ui-font-size-control
    font-weight: 600
    transition: color .2s ease, background-color .2s ease

    &:hover
      background-color: $ui-surface-soft
      opacity: 1

  input[type="radio"]
    &:focus-visible + .filters__item
      outline: 3px solid var(--ui-accent-soft, #{rgba($ui-blue, .18)})
      outline-offset: -3px

    &:checked + .filters__item
      background-color: var(--ui-accent-soft, #{$ui-blue-soft})
      color: var(--ui-accent, #{$ui-blue})

    &:checked + .filters__item--green
      background-color: $ui-green-soft
      color: $ui-green

    &:checked + .filters__item--red
      background-color: $ui-red-soft
      color: $ui-red

    &:checked + .filters__item--amber
      background-color: $ui-amber-soft
      color: $ui-amber

.filters--design-new.filters--refined
  .filters__item
    padding: 0 $ui-space-12

  input[type="radio"]:checked + .filters__item
    background-color: var(--ui-accent-soft, #{$ui-blue-soft})
    color: $ui-ink
    font-weight: 700

.filters--design-new.filters--medium
  .filters__item,
  input[type="radio"]:checked + .filters__item
    font-weight: 500

.filters--design-new.filters--refined.filters--medium
  position: relative
  width: max-content

  .filters__item
    min-height: $ui-control-height - 2px
    white-space: nowrap

.filters--design-new.filters--wrap
  flex-wrap: wrap

.filters--design-new.filters--refined.filters--medium.filters--wrap
  width: max-content
  max-width: 100%
</style>
